import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import MessageDialog from "../../components/MessageDialog";
import StorageService from "../../services/StorageService";
import FuelConsumptionReportService from "../../services/FuelConsumptionReportService";
import ProjectService from "../../services/ProjectService";
import VehicleRegistrationService from "../../services/vehicleRegistrationService";
// import VendorServices from "../../services/VendorServices";
import VehicleTypeService from "../../services/VehicleTypeService";
import utility from "../../utils/utility";
import ReactPaginate from "react-paginate";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import XLSX from "xlsx-js-style";
import logo from '../../assets/images/deviops_logo.png';
import { addPdfLogo, getPdfLogoDataUrl } from "../../utils/pdfLogo";

export default function FuelConsumptionReport() {
  const [reports, setReports] = useState([]);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [loading, setLoading] = useState(false);

  const [projects, setProjects] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);

  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [selectedVehicleId, setSelectedVehicleId] = useState("");
  const [selectedVendorId, setSelectedVendorId] = useState("");
  const [selectedVehicleTypeId, setSelectedVehicleTypeId] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const [summaryData, setSummaryData] = useState([]);
  const [companyScopeData, setCompanyScopeData] = useState([]);
  const [vendorScopeData, setVendorScopeData] = useState([]);

  const formatInputDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getCurrentMonthDateRange = () => {
    const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    return {
      startDate: formatInputDate(startDate),
      endDate: formatInputDate(endDate),
    };
  };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
  };

  const formatProjectDisplay = (project) => {
    if (!project) return "-";

    const projectName = project.projectName || project.name || "";
    const categoryName = project.projectCategoryName || project.categoryName || project.category || "";
    const projectCode = project.projectCode || "";
    const categoryInitial = String(categoryName).trim().charAt(0).toUpperCase();

    if (projectName) {
      if (categoryInitial) {
        return `${categoryInitial}*${projectName}`;
      }

      if (projectCode) {
        const codeInitial = String(projectCode).trim().charAt(0).toUpperCase();
        return `${codeInitial}*${projectName}`;
      }

      return projectName;
    }

    if (projectCode) {
      const codeInitial = String(projectCode).trim().charAt(0).toUpperCase();
      return `${codeInitial}*`;
    }

    return categoryInitial ? `${categoryInitial}*` : "-";
  };

  // Load projects
  const loadProjects = async () => {
    try {
      const companyId = StorageService.activeCompany().companyId;
      const res = await ProjectService.getActive(companyId);
      const data = res?.data || res || [];
      const mapped = data.map(p => ({
        id: p.id || p.projectId,
        projectName: p.projectName,
        projectCode: p.projectCode,
        projectCategoryName: p.projectCategoryName || p.categoryName || p.category
      }));
      setProjects(mapped);
    } catch {
      setProjects([]);
    }
  };

  // Load vehicle types
  const loadVehicleTypes = async () => {
    try {
      const res = await VehicleTypeService.getActiveVehicleTypes();
      const list = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
      setVehicleTypes(list);
    } catch (err) {
      console.error("Error loading vehicle types:", err);
      setVehicleTypes([]);
    }
  };

  // const loadVehicleOwners = async () => {

  //     try {

  //         const companyId = StorageService.activeCompany().companyId;

  //         const res = await VehicleRegistrationService.getAll(companyId);

  //         const vehiclesData = res?.data || res || [];

  //         const owners = vehiclesData.map(v => ({

  //             id: v.id,

  //             ownerName:
  //                 ["company", "self"].includes(
  //                     (v.ownerShipType || "").toLowerCase()
  //                 )
  //                     ? v.vehicleName
  //                     : v.vendorName

  //         }));

  //         setVendors(owners);

  //     } catch {

  //         setVendors([]);

  //     }
  // };

  // Load vendors
  //   const loadVendors = async () => {
  //     try {
  //       const res = await VendorServices.getByCategory(1); // 1 = Vehicle Owner category
  //       setVendors(res?.data || res || []);
  //     } catch {
  //       setVendors([]);
  //     }
  //   };



  // Load vehicles by project
  const fetchVehicles = async (projectId) => {
    if (!projectId) {
      setVehicles([]);
      return;
    }
    try {
      const res = await VehicleRegistrationService.getByProjectId(projectId, true);
      setVehicles(res?.status ? res.data : res?.data || res || []);
    } catch {
      setVehicles([]);
    }
  };

  const loadAllVehicles = async () => {
    try {
      const companyId = StorageService.activeCompany().companyId;
      const res = await VehicleRegistrationService.getAll(companyId);
      setVehicles(res?.data || res || []);
    } catch {
      setVehicles([]);
    }
  };

  const getVehicleOwnerName = (v) => {
    if (!v) return "";
    const isLease = (v.ownerShipType || "").toLowerCase() === "lease";
    return isLease
      ? (v.vendorName && v.vehicleName
          ? `${v.vendorName} (${v.vehicleName})`
          : (v.vendorName || v.vehicleName || "-"))
      : (v.vendorName || v.vehicleName || "-");
  };

  const availableVehicleTypes = React.useMemo(() => {
    if (selectedProjectId) {
      const typeMap = new Map();
      vehicles.forEach((v) => {
        const typeId = v.vehicleTypeId || v.typeId;
        if (typeId) {
          const typeName =
            v.vehicleType ||
            vehicleTypes.find((vt) => String(vt.id) === String(typeId))?.vehicleType;
          if (typeName) {
            typeMap.set(String(typeId), {
              id: typeId,
              vehicleType: typeName,
            });
          }
        }
      });
      return Array.from(typeMap.values()).sort((a, b) =>
        (a.vehicleType || "").localeCompare(b.vehicleType || "")
      );
    }
    return vehicleTypes;
  }, [selectedProjectId, vehicles, vehicleTypes]);

  const vehicleOwnersList = Array.from(
    new Set(
      vehicles
        .filter((v) => !selectedVehicleTypeId || String(v.vehicleTypeId) === String(selectedVehicleTypeId))
        .map((v) => getVehicleOwnerName(v))
        .filter((name) => name && name !== "-")
    )
  ).sort();

  useEffect(() => {
    loadProjects();
    loadVehicleTypes();
    loadAllVehicles();
    const { startDate: monthStart, endDate: monthEnd } = getCurrentMonthDateRange();
    setFromDate(monthStart);
    setToDate(monthEnd);
    handleSearch(1, { fromDate: monthStart, toDate: monthEnd });
  }, []);

  const handleProjectChange = async (e) => {
    const value = e.target.value;
    setSelectedProjectId(value);
    setSelectedVehicleId("");
    setSelectedVehicleTypeId("");
    setSelectedVendorId("");
    if (value) {
      await fetchVehicles(value);
    } else {
      await loadAllVehicles();
    }
  };

  const handleVehicleChange = (e) => {
    const vehicleId = e.target.value;
    setSelectedVehicleId(vehicleId);

    const selectedVehicle = vehicles.find(
      (v) => String(v.id) === String(vehicleId)
    );

    if (selectedVehicle) {
      if (selectedVehicle.vehicleTypeId) {
        setSelectedVehicleTypeId(String(selectedVehicle.vehicleTypeId));
      }
      const ownerName = getVehicleOwnerName(selectedVehicle);
      if (ownerName && ownerName !== "-") {
        setSelectedVendorId(ownerName);
      }
    }
  };

  const handleSearch = async (pageNo = currentPage, overrides = {}) => {
    setLoading(true);
    try {
      setReports([]);
      const companyId = StorageService.activeCompany().companyId;
      const requestFromDate = overrides.fromDate !== undefined ? overrides.fromDate : fromDate;
      const requestToDate = overrides.toDate !== undefined ? overrides.toDate : toDate;

      const res = await FuelConsumptionReportService.getReport({
        pageNumber: pageNo,
        noofRows: itemsPerPage,
        companyId,
        project: overrides.project !== undefined ? overrides.project : (selectedProjectId || null),
        vehicleName: overrides.vehicleName !== undefined ? overrides.vehicleName : (selectedVehicleId || null),
        vehicleType: overrides.vehicleType !== undefined ? overrides.vehicleType : (selectedVehicleTypeId || null),
        vendorName: overrides.vendorName !== undefined ? overrides.vendorName : (selectedVendorId || null),
        fromDate: requestFromDate || null,
        toDate: requestToDate || null
      });

      setReports(res.data || []);
      setSummaryData(res.summary || []);
      setCompanyScopeData(res.companyScope || []);
      setVendorScopeData(res.vendorScope || []);
      setPageCount(res.pagination?.totalPages || 1);
      setCurrentPage(pageNo);

    } catch (error) {
      console.error(error);
      showMessage("Error fetching fuel report", "error");
    } finally {
      setLoading(false);
    }
  };

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    handleSearch(newPage);
  };

  const handleSearchClick = () => {
    handleSearch(1);
  };

  const handleClearFilters = () => {
    const { startDate: monthStart, endDate: monthEnd } = getCurrentMonthDateRange();
    setSelectedProjectId("");
    setSelectedVehicleId("");
    setSelectedVendorId("");
    setSelectedVehicleTypeId("");
    setFromDate(monthStart);
    setToDate(monthEnd);
    loadAllVehicles();
    handleSearch(1, {
      project: null,
      vehicleType: null,
      vehicleName: null,
      vendorName: null,
      fromDate: monthStart,
      toDate: monthEnd
    });
  };

  // Summary by Fuel Type
  const buildFuelTypeSummary = (dataList) => {
    const result = {
      DIESEL: {
        internal: { liters: 0, amount: 0 },
        external: { liters: 0, amount: 0 }
      },
      PETROL: {
        internal: { liters: 0, amount: 0 },
        external: { liters: 0, amount: 0 }
      },
      GAS: {
        internal: { liters: 0, amount: 0 },
        external: { liters: 0, amount: 0 }
      },
      "ENGINE OIL": {
        internal: { liters: 0, amount: 0 },
        external: { liters: 0, amount: 0 }
      }
    };

    if (Array.isArray(dataList) && dataList.length > 0) {
      dataList.forEach(row => {
        let fuelType = (row.itemType || row.fuelType || "").toUpperCase();
        const source = (row.issuedTo || row.fuelSource || "").toUpperCase() === "INTERNAL"
          ? "internal"
          : "external";

        if (fuelType === "OIL") {
          fuelType = "ENGINE OIL";
        }

        if (result[fuelType]) {
          result[fuelType][source].liters += Number(row.qty || 0);
          result[fuelType][source].amount += Number(row.amount || 0);
        }
      });
      return result;
    }

    summaryData.forEach(row => {
      let fuelType = (row.fuelType || "").toUpperCase();
      const source = row.fuelSource === "INTERNAL"
        ? "internal"
        : "external";

      if (fuelType === "OIL") {
        fuelType = "ENGINE OIL";
      }

      if (result[fuelType]) {
        result[fuelType][source].liters += Number(row.totalLiters || 0);
        result[fuelType][source].amount += Number(row.totalAmount || 0);
      }
    });

    return result;
  };

  const buildCompanyScopeFromData = (dataList) => {
    const map = new Map();
    (dataList || []).filter(r => (r.issuedTo || r.fuelSource || "").toUpperCase() === "INTERNAL").forEach(r => {
      const pName = r.projectName || "";
      const oName = r.ownerName || "-";
      const vNo = r.vehicleNumber || "-";
      const fType = r.itemType || r.fuelType || "-";
      const key = `${pName}_${oName}_${vNo}_${fType}`;
      if (!map.has(key)) {
        map.set(key, {
          projectName: r.projectName,
          projectCode: r.projectCode,
          projectCategoryName: r.projectCategoryName,
          ownerName: oName,
          vehicleNumber: vNo,
          fuelType: fType,
          qty: 0,
          amount: 0
        });
      }
      const item = map.get(key);
      item.qty += Number(r.qty || 0);
      item.amount += Number(r.amount || 0);
    });
    return Array.from(map.values()).sort((a, b) => (a.projectName || "").localeCompare(b.projectName || ""));
  };

  const buildVendorScopeFromData = (dataList) => {
    const map = new Map();
    (dataList || []).filter(r => (r.issuedTo || r.fuelSource || "").toUpperCase() === "EXTERNAL").forEach(r => {
      const pName = r.projectName || "";
      const oName = r.ownerName || "-";
      const vNo = r.vehicleNumber || "-";
      const fType = r.itemType || r.fuelType || "-";
      const key = `${pName}_${oName}_${vNo}_${fType}`;
      if (!map.has(key)) {
        map.set(key, {
          projectName: r.projectName,
          projectCode: r.projectCode,
          projectCategoryName: r.projectCategoryName,
          ownerName: oName,
          vehicleNumber: vNo,
          fuelType: fType,
          qty: 0,
          amount: 0
        });
      }
      const item = map.get(key);
      item.qty += Number(r.qty || 0);
      item.amount += Number(r.amount || 0);
    });
    return Array.from(map.values()).sort((a, b) => (a.projectName || "").localeCompare(b.projectName || ""));
  };

  const validateExportFilters = () => {
    if (!reports || reports.length === 0) {
      showMessage("No data available to export", "info");
      return false;
    }
    return true;
  };

  const handleExportPDF = async () => {
    if (!validateExportFilters()) {
      return;
    }
    setLoading(true);
    try {
      const exportRows = await FuelConsumptionReportService.exportExcel({
        project: selectedProjectId || null,
        vehicleName: selectedVehicleId || null,
        vehicleType: selectedVehicleTypeId || null,
        vendorName: selectedVendorId || null,
        fromDate: fromDate || null,
        toDate: toDate || null
      });

      const allData = Array.isArray(exportRows) ? exportRows : (exportRows?.data || []);
      if (!allData || allData.length === 0) {
        showMessage("No data available to export", "info");
        setLoading(false);
        return;
      }

      const allReports = allData.map(r => ({
        ...r,
        fuelEntryDate: r.fuelEntryDate || r.FuelDate,
        projectName: r.projectName || r.ProjectName,
        projectCode: r.projectCode || r.ProjectCode,
        projectCategoryName: r.projectCategoryName || r.ProjectCategoryName,
        vehicleType: r.vehicleType || r.VehicleType || "-",
        vehicleNumber: r.vehicleNumber || r.VehicleNo || "-",
        ownerName: r.ownerName || r.OwnerName || "-",
        ownershipType: r.ownershipType || r.OwnershipType || "-",
        issuedTo: r.issuedTo || r.FuelSource || "-",
        itemType: r.itemType || r.FuelType || "-",
        qty: Number(r.qty ?? r.Qty ?? 0),
        rate: Number(r.rate ?? r.Rate ?? 0),
        amount: Number(r.amount ?? r.Amount ?? 0)
      }));

      const doc = new jsPDF("p", "mm", "a4");
      const pdfLogo = await getPdfLogoDataUrl(logo);
      const pageHeight = doc.internal.pageSize.getHeight();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageMargin = 14;
      const activeCompany = StorageService.activeCompany();
      const companyName = activeCompany?.companyName || "Devi Projects";

      const drawPageHeader = () => {
        doc.setFont(undefined, "bold");
        doc.setFontSize(12);
        const companyNameWidth = doc.getTextWidth(companyName);

        const logoWidth = 5;
        const logoHeight = 10;
        const logoX = pageMargin + 6 + (companyNameWidth - logoWidth) / 2;
        const logoY = 8;

        if (pdfLogo) {
          try {
            doc.addImage(pdfLogo, "PNG", logoX, logoY, logoWidth, logoHeight);
          } catch (e) {
            console.error("Error adding logo to PDF:", e);
          }
        }

        doc.text(companyName, pageMargin + 6, 23);

        doc.setFontSize(10);
        doc.setFont(undefined, "normal");
        doc.text(
          `Report Date: ${utility.formatExportDateTime(new Date())}`,
          pageWidth - pageMargin,
          23,
          { align: "right" }
        );

        const title = "Fuel Consumption Report";
        doc.setFontSize(18);
        doc.setFont(undefined, "bold");
        doc.text(title, pageWidth / 2, 35, { align: "center" });

        const titleWidth = doc.getTextWidth(title);
        doc.setLineWidth(0.3);
        doc.line(
          pageWidth / 2 - titleWidth / 2,
          37,
          pageWidth / 2 + titleWidth / 2,
          37
        );
      };

      let yPos = 10;

      drawPageHeader();
      yPos = 52;

      doc.setFontSize(10);

      const drawLabelValue = (label, val, y) => {
        doc.setFont(undefined, "bold");
        doc.text(String(label || ""), 14, y);
        doc.setFont(undefined, "normal");
        doc.text(String(val ?? "-"), 48, y);
      };

      drawLabelValue(
        "Project Name:",
        formatProjectDisplay(projects.find(p => String(p.id) === String(selectedProjectId))),
        yPos
      );
      yPos += 6;

      drawLabelValue(
        "Vehicle Type:",
        vehicleTypes.find(vt => String(vt.id) === String(selectedVehicleTypeId))?.vehicleType ||
        vehicles.find(v => String(v.id) === String(selectedVehicleId))?.vehicleType || "-",
        yPos
      );
      yPos += 6;

      drawLabelValue(
        "Vehicle Owner:",
        selectedVendorId ||
        (() => {
          const vehicle = vehicles.find(
            v => String(v.id) === String(selectedVehicleId)
          );
          if (!vehicle) return "-";
          return getVehicleOwnerName(vehicle) || "-";
        })(),
        yPos
      );
      yPos += 6;

      drawLabelValue(
        "Vehicle Number:",
        vehicles.find(v => String(v.id) === String(selectedVehicleId))?.registrationNo || "-",
        yPos
      );
      yPos += 6;

      drawLabelValue(
        "Start Date:",
        utility.formatDateDDMMMYYYY(fromDate) || "-",
        yPos
      );
      yPos += 6;

      drawLabelValue(
        "End Date:",
        utility.formatDateDDMMMYYYY(toDate) || "-",
        yPos
      );

      yPos += 10;

      const drawPageNumber = (pageNumber, totalPages) => {
        doc.setFont(undefined, "bold");
        doc.setFontSize(8);
        doc.text(`Page ${pageNumber} of ${totalPages}`, pageWidth / 2, pageHeight - 7, { align: "center" });
      };

      // Fuel Type Summary
      const fuelTypeSummary = buildFuelTypeSummary(allReports);

      const formatVal = (val, isTotal) => {
        if (val === 0) return isTotal ? "-" : "";
        return val.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      };

      const summaryBody = [
        [
          "Internal",
          formatVal(fuelTypeSummary["DIESEL"].internal.liters, false),
          formatVal(fuelTypeSummary["DIESEL"].internal.amount, false),
          formatVal(fuelTypeSummary["PETROL"].internal.liters, false),
          formatVal(fuelTypeSummary["PETROL"].internal.amount, false),
          formatVal(fuelTypeSummary["GAS"].internal.liters, false),
          formatVal(fuelTypeSummary["GAS"].internal.amount, false),
          formatVal(fuelTypeSummary["ENGINE OIL"].internal.liters, false),
          formatVal(fuelTypeSummary["ENGINE OIL"].internal.amount, false)
        ],
        [
          "External",
          formatVal(fuelTypeSummary["DIESEL"].external.liters, false),
          formatVal(fuelTypeSummary["DIESEL"].external.amount, false),
          formatVal(fuelTypeSummary["PETROL"].external.liters, false),
          formatVal(fuelTypeSummary["PETROL"].external.amount, false),
          formatVal(fuelTypeSummary["GAS"].external.liters, false),
          formatVal(fuelTypeSummary["GAS"].external.amount, false),
          formatVal(fuelTypeSummary["ENGINE OIL"].external.liters, false),
          formatVal(fuelTypeSummary["ENGINE OIL"].external.amount, false)
        ],
        [
          "Total",
          formatVal(fuelTypeSummary["DIESEL"].internal.liters + fuelTypeSummary["DIESEL"].external.liters, true),
          formatVal(fuelTypeSummary["DIESEL"].internal.amount + fuelTypeSummary["DIESEL"].external.amount, true),
          formatVal(fuelTypeSummary["PETROL"].internal.liters + fuelTypeSummary["PETROL"].external.liters, true),
          formatVal(fuelTypeSummary["PETROL"].internal.amount + fuelTypeSummary["PETROL"].external.amount, true),
          formatVal(fuelTypeSummary["GAS"].internal.liters + fuelTypeSummary["GAS"].external.liters, true),
          formatVal(fuelTypeSummary["GAS"].internal.amount + fuelTypeSummary["GAS"].external.amount, true),
          formatVal(fuelTypeSummary["ENGINE OIL"].internal.liters + fuelTypeSummary["ENGINE OIL"].external.liters, true),
          formatVal(fuelTypeSummary["ENGINE OIL"].internal.amount + fuelTypeSummary["ENGINE OIL"].external.amount, true)
        ]
      ];

      autoTable(doc, {
        startY: yPos,
        margin: { top: 48, left: 14, right: 14, bottom: 20 },
        head: [
          [
            { content: "", rowSpan: 2, styles: { fillColor: [230, 230, 230], textColor: [0, 0, 0] } },
            { content: "Diesel", colSpan: 2, styles: { halign: "center" } },
            { content: "Petrol", colSpan: 2, styles: { halign: "center" } },
            { content: "Gas", colSpan: 2, styles: { halign: "center" } },
            { content: "Engine oil", colSpan: 2, styles: { halign: "center" } }
          ],
          [
            "Litre(s)",
            "Amount",
            "Litre(s)",
            "Amount",
            "Litre(s)",
            "Amount",
            "Litre(s)",
            "Amount"
          ]
        ],
        body: summaryBody,
        theme: "grid",
        styles: {
          fontSize: 8,
          lineColor: [180, 180, 180],
          lineWidth: 0.3
        },
        columnStyles: {
          0: { halign: "left" },
          1: { halign: "right" },
          2: { halign: "right" },
          3: { halign: "right" },
          4: { halign: "right" },
          5: { halign: "right" },
          6: { halign: "right" },
          7: { halign: "right" },
          8: { halign: "right" }
        },
        headStyles: {
          fillColor: [230, 230, 230],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          halign: "center",
          lineWidth: 0.3,
          lineColor: [180, 180, 180]
        },
        didParseCell: function (data) {
          if (
            data.row.section === "body" &&
            data.column.index === 0
          ) {
            data.cell.styles.fontStyle = "bold";
          }

          if (
            data.row.section === "body" &&
            data.row.index === 2
          ) {
            data.cell.styles.fillColor = [220, 220, 220];
          }
        },
      });

      yPos = doc.lastAutoTable.finalY + 10;

      // Detail Table
      const detailBody = allReports.map(r => [
        utility.formatDateDDMMMYYYY(r.fuelEntryDate),
        formatProjectDisplay(r),
        r.vehicleType || "-",
        r.vehicleNumber || "-",
        r.ownerName || "-",
        r.ownershipType || "-",
        r.issuedTo || "-",
        r.itemType || "-",
        Number(r.qty || 0).toFixed(2),
        Number(r.rate || 0).toFixed(2),
        Number(r.amount || 0).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      ]);
      const totalQty = allReports.reduce(
        (sum, r) => sum + Number(r.qty || 0),
        0
      );

      const totalAmount = allReports.reduce(
        (sum, r) => sum + Number(r.amount || 0),
        0
      );

      detailBody.push([
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "Total:",
        totalQty.toFixed(2),
        "",
        totalAmount.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      ]);

      autoTable(doc, {
        startY: yPos,
        margin: { top: 48, left: 14, right: 14, bottom: 20 },
        head: [["Date", "Project Name", "Vehicle Type", "Vehicle No", "Owner", "Owner Ship", "Issued To", "Item", "Qty(L)", "Rate", "Amount"]],
        body: detailBody,
        theme: "grid",
        styles: {
          fontSize: 7,
          lineColor: [180, 180, 180],
          lineWidth: 0.3
        },
        columnStyles: {
          0: { halign: "center" },
          1: { halign: "left" },
          2: { halign: "left" },
          3: { halign: "left" },
          4: { halign: "left" },
          5: { halign: "left" },
          6: { halign: "left" },
          7: { halign: "left" },
          8: { halign: "right" },
          9: { halign: "right" },
          10: { halign: "right" }
        },
        headStyles: {
          fillColor: [230, 230, 230],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          halign: "center",
          lineColor: [180, 180, 180],
          lineWidth: 0.3
        },
        didParseCell: function (data) {
          if (
            data.row.section === "body" &&
            data.row.index === data.table.body.length - 1
          ) {
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.fillColor = [220, 220, 220];
          }
        },
      });

      yPos = doc.lastAutoTable.finalY + 10;

      const companyScopeToUse = (companyScopeData && companyScopeData.length > 0)
        ? companyScopeData
        : buildCompanyScopeFromData(allReports);

      if (companyScopeToUse.length > 0) {
        if (yPos + 25 > pageHeight - 20) {
          doc.addPage();
          yPos = 48;
        }

        doc.setFontSize(10);
        doc.setFont(undefined, "bold");
        doc.text("Company Scope (Internal):", 14, yPos);
        yPos += 5;

        const companyBody = companyScopeToUse.map((r, index) => [
          index + 1,
          formatProjectDisplay(r),
          r.ownerName || "-",
          r.vehicleNumber || "-",
          r.fuelType || r.itemType || "-",
          Number(r.qty || 0).toFixed(2),
          Number(r.amount || 0).toFixed(2)
        ]);

        const companyTotalQty = companyScopeToUse.reduce((sum, r) => sum + Number(r.qty || 0), 0);
        const companyTotalAmount = companyScopeToUse.reduce((sum, r) => sum + Number(r.amount || 0), 0);

        companyBody.push([
          "",
          "",
          "",
          "",
          "Total:",
          companyTotalQty.toFixed(2),
          companyTotalAmount.toFixed(2)
        ]);

        autoTable(doc, {
          startY: yPos,
          margin: { top: 48, left: 14, right: 14, bottom: 20 },
          head: [[
            "S.No",
            "Project Name",
            "Vehicle Owner",
            "Vehicle No",
            "Fuel Type",
            "Qty(Ltrs)",
            "Amount"
          ]],
          body: companyBody,
          theme: "grid",
          styles: {
            fontSize: 8,
            lineColor: [180, 180, 180],
            lineWidth: 0.3
          },
          columnStyles: {
            0: { halign: "center" },
            1: { halign: "left" },
            2: { halign: "left" },
            3: { halign: "left" },
            4: { halign: "left" },
            5: { halign: "right" },
            6: { halign: "right" }
          },
          headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0],
            fontStyle: "bold",
            halign: "center",
            lineColor: [180, 180, 180],
            lineWidth: 0.3
          },
          didParseCell: function (data) {
            if (
              data.row.section === "body" &&
              data.row.index === data.table.body.length - 1
            ) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.fillColor = [220, 220, 220];
            }
          }
        });

        yPos = doc.lastAutoTable.finalY + 10;
      }

      const vendorScopeToUse = (vendorScopeData && vendorScopeData.length > 0)
        ? vendorScopeData
        : buildVendorScopeFromData(allReports);

      if (vendorScopeToUse.length > 0) {
        if (yPos + 25 > pageHeight - 20) {
          doc.addPage();
          yPos = 48;
        }

        doc.setFontSize(10);
        doc.setFont(undefined, "bold");
        doc.text("Vendor Scope (External):", 14, yPos);
        yPos += 5;

        const vendorBody = vendorScopeToUse.map((r, index) => [
          index + 1,
          formatProjectDisplay(r),
          r.ownerName || "-",
          r.vehicleNumber || "-",
          r.fuelType || r.itemType || "-",
          Number(r.qty || 0).toFixed(2),
          Number(r.amount || 0).toFixed(2)
        ]);

        const vendorTotalQty = vendorScopeToUse.reduce((sum, r) => sum + Number(r.qty || 0), 0);
        const vendorTotalAmount = vendorScopeToUse.reduce((sum, r) => sum + Number(r.amount || 0), 0);

        vendorBody.push([
          "",
          "",
          "",
          "",
          "Total:",
          vendorTotalQty.toFixed(2),
          vendorTotalAmount.toFixed(2)
        ]);

        autoTable(doc, {
          startY: yPos,
          margin: { top: 48, left: 14, right: 14, bottom: 20 },
          head: [[
            "S.No",
            "Project Name",
            "Vehicle Owner",
            "Vehicle No",
            "Fuel Type",
            "Qty(Ltrs)",
            "Amount"
          ]],
          body: vendorBody,
          theme: "grid",
          styles: {
            fontSize: 8,
            lineColor: [180, 180, 180],
            lineWidth: 0.3
          },
          columnStyles: {
            0: { halign: "center" },
            1: { halign: "left" },
            2: { halign: "left" },
            3: { halign: "left" },
            4: { halign: "left" },
            5: { halign: "right" },
            6: { halign: "right" }
          },
          headStyles: {
            fillColor: [230, 230, 230],
            textColor: [0, 0, 0],
            fontStyle: "bold",
            halign: "center",
            lineColor: [180, 180, 180],
            lineWidth: 0.3
          },
          didParseCell: function (data) {
            if (
              data.row.section === "body" &&
              data.row.index === data.table.body.length - 1
            ) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.fillColor = [220, 220, 220];
            }
          },
        });

        yPos = doc.lastAutoTable.finalY + 15;
      }

      if (doc.lastAutoTable && doc.lastAutoTable.finalY > pageHeight - 25) {
        doc.addPage();
      }

      // Page numbers & header on page 2+
      const pageCount = doc.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        if (i > 1) {
          drawPageHeader();
        }
        drawPageNumber(i, pageCount);

        // Only last page
        if (i === pageCount) {
          doc.setFontSize(10);
          doc.text("Prepared By", 20, pageHeight - 20);
          doc.text("Checked By", pageWidth / 2, pageHeight - 20, { align: "center" });
          doc.text("Approved By", pageWidth - 20, pageHeight - 20, { align: "right" });
        }
      }

      doc.save(`Fuel_Consumption_Report_${utility.formatDateDDMMMYYYY(new Date())}.pdf`);
    } catch (error) {
      console.error("PDF export error:", error);
      showMessage("Error exporting PDF", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleExportExcel = async () => {
    if (!validateExportFilters()) {
      return;
    }
    setLoading(true);
    try {
      const exportRows = await FuelConsumptionReportService.exportExcel({
        project: selectedProjectId || null,
        vehicleName: selectedVehicleId || null,
        vehicleType: selectedVehicleTypeId || null,
        vendorName: selectedVendorId || null,
        fromDate: fromDate || null,
        toDate: toDate || null
      });

      const allData = Array.isArray(exportRows) ? exportRows : (exportRows?.data || []);
      if (!allData || allData.length === 0) {
        showMessage("No data available to export", "info");
        setLoading(false);
        return;
      }

      const allReports = allData.map(r => ({
        ...r,
        fuelEntryDate: r.fuelEntryDate || r.FuelDate,
        projectName: r.projectName || r.ProjectName,
        projectCode: r.projectCode || r.ProjectCode,
        projectCategoryName: r.projectCategoryName || r.ProjectCategoryName,
        vehicleType: r.vehicleType || r.VehicleType || "-",
        vehicleNumber: r.vehicleNumber || r.VehicleNo || "-",
        ownerName: r.ownerName || r.OwnerName || "-",
        ownershipType: r.ownershipType || r.OwnershipType || "-",
        issuedTo: r.issuedTo || r.FuelSource || "-",
        itemType: r.itemType || r.FuelType || "-",
        qty: Number(r.qty ?? r.Qty ?? 0),
        rate: Number(r.rate ?? r.Rate ?? 0),
        amount: Number(r.amount ?? r.Amount ?? 0)
      }));

      const wb = XLSX.utils.book_new();
      const ws = {};
      ws["!merges"] = [];

      const thin = { style: "thin" };
      const cellBorder = { top: thin, bottom: thin, left: thin, right: thin };
      const center = { horizontal: "center", vertical: "center", wrapText: true };
      const labelStyle = {
        font: { bold: true, sz: 10 },
        alignment: { horizontal: "left", vertical: "center" },
        border: cellBorder
      };
      const valueStyle = {
        font: { sz: 10 },
        alignment: { horizontal: "left", vertical: "center", wrapText: true },
        border: cellBorder
      };
      const numStyle = {
        font: { sz: 10 },
        alignment: { horizontal: "right", vertical: "center" },
        border: cellBorder
      };
      const tableHeaderStyle = {
        font: { bold: true, sz: 11 },
        alignment: center,
        border: cellBorder,
        fill: { fgColor: { rgb: "FFD9D9D9" } }
      };
      const totalLabelStyle = {
        font: { bold: true, sz: 10 },
        alignment: { horizontal: "right", vertical: "center" },
        border: cellBorder
      };
      const totalValueStyle = {
        font: { bold: true, sz: 10 },
        alignment: { horizontal: "right", vertical: "center" },
        border: cellBorder
      };

      const MAX_COL = 10;

      const styleCells = (r, colCount, styleForCol) => {
        for (let c = 0; c < colCount; c++) {
          const cell = XLSX.utils.encode_cell({ r, c });
          if (!ws[cell]) ws[cell] = { v: "", t: "s" };
          ws[cell].s = styleForCol(c);
        }
      };

      const addDataRow = (rowData, styleForCol) => {
        const r = row;
        XLSX.utils.sheet_add_aoa(ws, [rowData], { origin: { r, c: 0 } });
        styleCells(r, rowData.length, styleForCol);
        row++;
      };

      const styleFilterBlock = (startR, rowCount) => {
        const boldLabelColumns = [0, 3];
        for (let i = 0; i < rowCount; i++) {
          for (let c = 0; c < 5; c++) {
            const cell = XLSX.utils.encode_cell({ r: startR + i, c });
            if (!ws[cell]) continue;
            ws[cell].s = boldLabelColumns.includes(c) ? labelStyle : valueStyle;
          }
        }
      };

      let row = 0;
      const companyName = StorageService.activeCompany()?.companyName || "";
      const selectedVehicle = vehicles.find((v) => String(v.id) === String(selectedVehicleId));
      const selectedTypeObj = vehicleTypes.find((vt) => String(vt.id) === String(selectedVehicleTypeId));
      const ownerName = selectedVendorId || (selectedVehicle ? getVehicleOwnerName(selectedVehicle) : "-");
      const vehicleTypeDisplay = selectedTypeObj?.vehicleType || selectedVehicle?.vehicleType || "-";
      const projectName = formatProjectDisplay(projects.find((p) => String(p.id) === String(selectedProjectId)) || { projectName: selectedProjectId });
      const fuelTypeSummary = buildFuelTypeSummary(allReports);

      XLSX.utils.sheet_add_aoa(ws, [[companyName]], { origin: { r: row, c: 0 } });
      ws[XLSX.utils.encode_cell({ r: row, c: 0 })].s = {
        font: { bold: true, sz: 12 },
        alignment: { horizontal: "left", vertical: "center" }
      };
      XLSX.utils.sheet_add_aoa(
        ws,
        [[`Report Date: ${utility.formatExportDateTime(new Date())}`]],
        { origin: { r: row, c: MAX_COL } }
      );
      ws[XLSX.utils.encode_cell({ r: row, c: MAX_COL })].s = {
        font: { bold: true, sz: 10 },
        alignment: { horizontal: "right", vertical: "center" }
      };
      row++;

      XLSX.utils.sheet_add_aoa(ws, [["Fuel Consumption Report"]], { origin: { r: row, c: 0 } });
      ws["!merges"].push({ s: { r: row, c: 0 }, e: { r: row, c: MAX_COL } });
      ws[XLSX.utils.encode_cell({ r: row, c: 0 })].s = {
        font: { bold: true, sz: 16 },
        alignment: { horizontal: "center", vertical: "center" }
      };
      row += 2;

      const filterStartRow = row;
      XLSX.utils.sheet_add_aoa(
        ws,
        [
          ["Project Name:", projectName, "", "Vehicle Owner:", ownerName],
          ["Vehicle Type:", vehicleTypeDisplay, "", "Vehicle Number:", selectedVehicle?.registrationNo || "-"],
          ["Start Date:", utility.formatDateDDMMMYYYY(fromDate), "", "End Date:", utility.formatDateDDMMMYYYY(toDate)]
        ],
        { origin: { r: row, c: 0 } }
      );
      styleFilterBlock(filterStartRow, 3);
      row += 3;
      row++;

      const summaryHeadersRow1 = [
        "", "",
        "Diesel", "",
        "Petrol", "",
        "Gas", "",
        "Engine Oil", ""
      ];
      const summaryHeadersRow2 = [
        "", "",
        "Litre(s)", "Amount",
        "Litre(s)", "Amount",
        "Litre(s)", "Amount",
        "Litre(s)", "Amount"
      ];

      ws["!merges"].push({ s: { r: row, c: 0 }, e: { r: row, c: 1 } });
      ws["!merges"].push({ s: { r: row, c: 2 }, e: { r: row, c: 3 } });
      ws["!merges"].push({ s: { r: row, c: 4 }, e: { r: row, c: 5 } });
      ws["!merges"].push({ s: { r: row, c: 6 }, e: { r: row, c: 7 } });
      ws["!merges"].push({ s: { r: row, c: 8 }, e: { r: row, c: 9 } });
      addDataRow(summaryHeadersRow1, () => tableHeaderStyle);

      ws["!merges"].push({ s: { r: row, c: 0 }, e: { r: row, c: 1 } });
      addDataRow(summaryHeadersRow2, () => tableHeaderStyle);

      const formatVal = (val, isTotal) => {
        if (val === 0) return isTotal ? "-" : "";
        return val.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      };

      const summaryRows = [
        [
          "",
          "Internal",
          formatVal(fuelTypeSummary["DIESEL"].internal.liters, false),
          formatVal(fuelTypeSummary["DIESEL"].internal.amount, false),
          formatVal(fuelTypeSummary["PETROL"].internal.liters, false),
          formatVal(fuelTypeSummary["PETROL"].internal.amount, false),
          formatVal(fuelTypeSummary["GAS"].internal.liters, false),
          formatVal(fuelTypeSummary["GAS"].internal.amount, false),
          formatVal(fuelTypeSummary["ENGINE OIL"].internal.liters, false),
          formatVal(fuelTypeSummary["ENGINE OIL"].internal.amount, false)
        ],
        [
          "",
          "External",
          formatVal(fuelTypeSummary["DIESEL"].external.liters, false),
          formatVal(fuelTypeSummary["DIESEL"].external.amount, false),
          formatVal(fuelTypeSummary["PETROL"].external.liters, false),
          formatVal(fuelTypeSummary["PETROL"].external.amount, false),
          formatVal(fuelTypeSummary["GAS"].external.liters, false),
          formatVal(fuelTypeSummary["GAS"].external.amount, false),
          formatVal(fuelTypeSummary["ENGINE OIL"].external.liters, false),
          formatVal(fuelTypeSummary["ENGINE OIL"].external.amount, false)
        ],
        [
          "",
          "Total",
          formatVal(fuelTypeSummary["DIESEL"].internal.liters + fuelTypeSummary["DIESEL"].external.liters, true),
          formatVal(fuelTypeSummary["DIESEL"].internal.amount + fuelTypeSummary["DIESEL"].external.amount, true),
          formatVal(fuelTypeSummary["PETROL"].internal.liters + fuelTypeSummary["PETROL"].external.liters, true),
          formatVal(fuelTypeSummary["PETROL"].internal.amount + fuelTypeSummary["PETROL"].external.amount, true),
          formatVal(fuelTypeSummary["GAS"].internal.liters + fuelTypeSummary["GAS"].external.liters, true),
          formatVal(fuelTypeSummary["GAS"].internal.amount + fuelTypeSummary["GAS"].external.amount, true),
          formatVal(fuelTypeSummary["ENGINE OIL"].internal.liters + fuelTypeSummary["ENGINE OIL"].external.liters, true),
          formatVal(fuelTypeSummary["ENGINE OIL"].internal.amount + fuelTypeSummary["ENGINE OIL"].external.amount, true)
        ]
      ];

      summaryRows.forEach((dataRow, rowIndex) => {
        addDataRow(dataRow, (c) => {
          if (c === 0 || c === 1) {
            return rowIndex === 2
              ? { ...labelStyle, font: { bold: true, sz: 10 } }
              : labelStyle;
          }
          return rowIndex === 2
            ? { ...numStyle, font: { bold: true } }
            : numStyle;
        });
      });

      row++;

      const detailHeaders = [
        "Date",
        "Project Name",
        "Vehicle Type",
        "Vehicle No",
        "Owner",
        "Owner Ship",
        "Issued To",
        "Item",
        "Qty(L)",
        "Rate",
        "Amount"
      ];
      const headerRowIndex = row;
      addDataRow(detailHeaders, () => tableHeaderStyle);

      allReports.forEach((r) => {
        const qtyVal = Number(r.qty || 0);
        const rateVal = Number(r.rate || 0);
        const amtVal = Number(r.amount || 0);
        const dateSerial = utility.convertDateToExcelSerial(r.fuelEntryDate);
        const startR = row;
        addDataRow(
          [
            dateSerial || "-",
            formatProjectDisplay(r),
            r.vehicleType || "-",
            r.vehicleNumber || "-",
            r.ownerName || "-",
            r.ownershipType || "-",
            r.issuedTo || "-",
            r.itemType || "-",
            qtyVal,
            rateVal,
            amtVal
          ],
          (c) => (c >= 8 ? numStyle : valueStyle)
        );
        const cellD = XLSX.utils.encode_cell({ r: startR, c: 0 });
        if (ws[cellD] && dateSerial) { ws[cellD].t = "n"; ws[cellD].v = dateSerial; ws[cellD].z = "dd-mm-yyyy"; }
        const cellQ = XLSX.utils.encode_cell({ r: startR, c: 8 });
        if (ws[cellQ]) { ws[cellQ].t = "n"; ws[cellQ].v = qtyVal; ws[cellQ].z = "#,##0.00"; }
        const cellR = XLSX.utils.encode_cell({ r: startR, c: 9 });
        if (ws[cellR]) { ws[cellR].t = "n"; ws[cellR].v = rateVal; ws[cellR].z = "#,##0.00"; }
        const cellA = XLSX.utils.encode_cell({ r: startR, c: 10 });
        if (ws[cellA]) { ws[cellA].t = "n"; ws[cellA].v = amtVal; ws[cellA].z = "#,##0.00"; }
      });

      const totalQty = allReports.reduce((sum, r) => sum + Number(r.qty || 0), 0);
      const totalAmount = allReports.reduce((sum, r) => sum + Number(r.amount || 0), 0);
      const totalsRow = ["", "", "", "", "", "", "", "Total:", totalQty, "", totalAmount];
      const totR = row;
      addDataRow(totalsRow, (c) => {
        if (c === 7) return totalLabelStyle;
        if (c === 8 || c === 10) return totalValueStyle;
        return valueStyle;
      });
      const cellTQ = XLSX.utils.encode_cell({ r: totR, c: 8 });
      if (ws[cellTQ]) { ws[cellTQ].t = "n"; ws[cellTQ].v = totalQty; ws[cellTQ].z = "#,##0.00"; }
      const cellTA = XLSX.utils.encode_cell({ r: totR, c: 10 });
      if (ws[cellTA]) { ws[cellTA].t = "n"; ws[cellTA].v = totalAmount; ws[cellTA].z = "#,##0.00"; }

      ws["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: { r: headerRowIndex, c: 0 },
          e: { r: totR, c: detailHeaders.length - 1 }
        })
      };

      row++;

      const scopeHeaders = [
        "S.No",
        "Project Name",
        "Vehicle Owner",
        "Vehicle No",
        "Fuel Type",
        "Qty(Ltrs)",
        "Amount"
      ];

      const companyScopeToUse = (companyScopeData && companyScopeData.length > 0)
        ? companyScopeData
        : buildCompanyScopeFromData(allReports);

      if (companyScopeToUse.length > 0) {
        XLSX.utils.sheet_add_aoa(ws, [["Company Scope (Internal)"]], { origin: { r: row, c: 0 } });
        ws[XLSX.utils.encode_cell({ r: row, c: 0 })].s = {
          font: { bold: true, sz: 11 },
          alignment: { horizontal: "left", vertical: "center" }
        };
        row++;
        row++;

        addDataRow(scopeHeaders, () => tableHeaderStyle);
        companyScopeToUse.forEach((r, index) => {
          const qtyVal = Number(r.qty || 0);
          const amtVal = Number(r.amount || 0);
          const startR = row;
          addDataRow(
            [
              index + 1,
              formatProjectDisplay(r),
              r.ownerName || "-",
              r.vehicleNumber || "-",
              r.fuelType || r.itemType || "-",
              qtyVal,
              amtVal
            ],
            (c) => (c === 0 || c >= 5 ? numStyle : valueStyle)
          );
          const cellQ = XLSX.utils.encode_cell({ r: startR, c: 5 });
          if (ws[cellQ]) { ws[cellQ].t = "n"; ws[cellQ].v = qtyVal; ws[cellQ].z = "#,##0.00"; }
          const cellA = XLSX.utils.encode_cell({ r: startR, c: 6 });
          if (ws[cellA]) { ws[cellA].t = "n"; ws[cellA].v = amtVal; ws[cellA].z = "#,##0.00"; }
        });
        const cTotQty = companyScopeToUse.reduce((sum, r) => sum + Number(r.qty || 0), 0);
        const cTotAmt = companyScopeToUse.reduce((sum, r) => sum + Number(r.amount || 0), 0);
        const cTotR = row;
        addDataRow(["", "", "", "", "Total:", cTotQty, cTotAmt], (c) => {
          if (c === 4) return totalLabelStyle;
          if (c >= 5) return totalValueStyle;
          return valueStyle;
        });
        const cellCTQ = XLSX.utils.encode_cell({ r: cTotR, c: 5 });
        if (ws[cellCTQ]) { ws[cellCTQ].t = "n"; ws[cellCTQ].v = cTotQty; ws[cellCTQ].z = "#,##0.00"; }
        const cellCTA = XLSX.utils.encode_cell({ r: cTotR, c: 6 });
        if (ws[cellCTA]) { ws[cellCTA].t = "n"; ws[cellCTA].v = cTotAmt; ws[cellCTA].z = "#,##0.00"; }

        row++;
      }

      const vendorScopeToUse = (vendorScopeData && vendorScopeData.length > 0)
        ? vendorScopeData
        : buildVendorScopeFromData(allReports);

      if (vendorScopeToUse.length > 0) {
        XLSX.utils.sheet_add_aoa(ws, [["Vendor Scope (External)"]], { origin: { r: row, c: 0 } });
        ws[XLSX.utils.encode_cell({ r: row, c: 0 })].s = {
          font: { bold: true, sz: 11 },
          alignment: { horizontal: "left", vertical: "center" }
        };
        row++;
        row++;

        addDataRow(scopeHeaders, () => tableHeaderStyle);
        vendorScopeToUse.forEach((r, index) => {
          const qtyVal = Number(r.qty || 0);
          const amtVal = Number(r.amount || 0);
          const startR = row;
          addDataRow(
            [
              index + 1,
              formatProjectDisplay(r),
              r.ownerName || "-",
              r.vehicleNumber || "-",
              r.fuelType || r.itemType || "-",
              qtyVal,
              amtVal
            ],
            (c) => (c === 0 || c >= 5 ? numStyle : valueStyle)
          );
          const cellQ = XLSX.utils.encode_cell({ r: startR, c: 5 });
          if (ws[cellQ]) { ws[cellQ].t = "n"; ws[cellQ].v = qtyVal; ws[cellQ].z = "#,##0.00"; }
          const cellA = XLSX.utils.encode_cell({ r: startR, c: 6 });
          if (ws[cellA]) { ws[cellA].t = "n"; ws[cellA].v = amtVal; ws[cellA].z = "#,##0.00"; }
        });
        const vTotQty = vendorScopeToUse.reduce((sum, r) => sum + Number(r.qty || 0), 0);
        const vTotAmt = vendorScopeToUse.reduce((sum, r) => sum + Number(r.amount || 0), 0);
        const vTotR = row;
        addDataRow(["", "", "", "", "Total:", vTotQty, vTotAmt], (c) => {
          if (c === 4) return totalLabelStyle;
          if (c >= 5) return totalValueStyle;
          return valueStyle;
        });
        const cellVTQ = XLSX.utils.encode_cell({ r: vTotR, c: 5 });
        if (ws[cellVTQ]) { ws[cellVTQ].t = "n"; ws[cellVTQ].v = vTotQty; ws[cellVTQ].z = "#,##0.00"; }
        const cellVTA = XLSX.utils.encode_cell({ r: vTotR, c: 6 });
        if (ws[cellVTA]) { ws[cellVTA].t = "n"; ws[cellVTA].v = vTotAmt; ws[cellVTA].z = "#,##0.00"; }
      }

      ws["!cols"] = [
        { wch: 14 },
        { wch: 20 },
        { wch: 16 },
        { wch: 14 },
        { wch: 18 },
        { wch: 14 },
        { wch: 16 },
        { wch: 14 },
        { wch: 12 },
        { wch: 12 },
        { wch: 14 }
      ];

      ws["!ref"] = XLSX.utils.encode_range({
        s: { r: 0, c: 0 },
        e: { r: row, c: MAX_COL }
      });

      XLSX.utils.book_append_sheet(wb, ws, "Fuel Consumption");
      XLSX.writeFile(
        wb,
        `Fuel_Consumption_Report_${utility.formatDateDDMMMYYYY(new Date())}.xlsx`
      );
    } catch (error) {
      console.error("Excel export error:", error);
      showMessage("Error exporting Excel", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb pageTitle="Fuel Consumption Report" secondTitle="Fuel Management" />

      <MessageDialog
        message={message}
        type={msgType}
        setMessage={setMessage}
        setMsgType={setMsgType}
      />

      <div className="row">
        <div className="card py-3 bg-white shadow-sm">

          {/* Filters Section */}
          <div className="row mb-3 px-3">

            {/* Project Dropdown */}
            <div className="col-md-3 mb-2">
              <label className="form-label">Project</label>
              <select
                className="form-select"
                value={selectedProjectId}
                onChange={handleProjectChange}
              >
                <option value="">All Projects</option>
                {projects.map((p) => (
                  <option key={p.id} value={p.id}>
                    {formatProjectDisplay(p)}
                  </option>
                ))}
              </select>
            </div>

            {/* Vehicle Type Dropdown */}
            <div className="col-md-3 mb-2">
              <label className="form-label">Vehicle Type</label>
              <select
                className="form-select"
                value={selectedVehicleTypeId}
                onChange={(e) => {
                  const val = e.target.value;
                  setSelectedVehicleTypeId(val);
                  if (selectedVehicleId) {
                    const sel = vehicles.find((v) => String(v.id) === String(selectedVehicleId));
                    if (sel && String(sel.vehicleTypeId) !== String(val) && val !== "") {
                      setSelectedVehicleId("");
                    }
                  }
                }}
              >
                <option value="">All Vehicle Types</option>
                {availableVehicleTypes.map((vt) => (
                  <option key={vt.id} value={vt.id}>
                    {vt.vehicleType}
                  </option>
                ))}
              </select>
            </div>

            {/* Vehicle Dropdown */}
            <div className="col-md-3 mb-2">
              <label className="form-label">Vehicle</label>
              <select
                className="form-select"
                value={selectedVehicleId}
                onChange={handleVehicleChange}
              >
                <option value="">All Vehicles</option>
                {vehicles
                  .filter((v) => !selectedVehicleTypeId || String(v.vehicleTypeId) === String(selectedVehicleTypeId))
                  .filter((v) => !selectedVendorId || getVehicleOwnerName(v) === selectedVendorId)
                  .map((v) => (
                    <option key={v.id} value={v.id}>
                      {v.vehicleName}-{v.registrationNo}
                    </option>
                  ))}
              </select>
            </div>

            {/* Vehicle Owner Dropdown */}
            <div className="col-md-3 mb-2">
              <label className="form-label">Vehicle Owner</label>
              <select
                className="form-select"
                value={selectedVendorId}
                onChange={(e) => {
                  const val = e.target.value;
                  setSelectedVendorId(val);
                  if (selectedVehicleId) {
                    const sel = vehicles.find((v) => String(v.id) === String(selectedVehicleId));
                    if (sel && getVehicleOwnerName(sel) !== val && val !== "") {
                      setSelectedVehicleId("");
                    }
                  }
                }}
              >
                <option value="">All Vehicle Owners</option>
                {vehicleOwnersList.map((ownerName) => (
                  <option key={ownerName} value={ownerName}>
                    {ownerName}
                  </option>
                ))}
              </select>
            </div>

            {/* From Date */}
            <div className="col-md-3 mb-2">
              <label className="form-label">From Date</label>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            {/* To Date */}
            <div className="col-md-3 mb-2">
              <label className="form-label">To Date</label>
              <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>

          </div>



          {/* Search Button */}
          <div className="mb-3 d-flex justify-content-end align-items-center">



            {/* Right Side */}
            <div className="d-flex gap-2">
              <button
                className="btn btn-secondary"
                onClick={handleClearFilters}
              >
                <i className="ti ti-refresh me-1"></i>
                Clear
              </button>

              <button
                className="btn btn-primary"
                onClick={handleSearchClick}
                disabled={loading}
              >
                <i className="ti ti-search me-1"></i>
                {loading ? "Searching..." : "View Report"}
              </button>
            </div>

          </div>
          <hr />
          <div className="mb-3 d-flex justify-content-end align-items-center">

            {/* Left Side */}
            <div className="d-flex gap-2">
              <button
                className="btn btn-success"
                onClick={handleExportPDF}
                disabled={loading}
              >
                Export PDF
              </button>

              <button
                className="btn btn-success"
                onClick={handleExportExcel}
                disabled={loading}
              >
                Export Excel
              </button>
            </div>



          </div>



          {/* Detail Table */}
          <div className="px-3 mb-4">
            <h6 className="mb-2"><strong>Fuel Consumption Details</strong></h6>
            <div className="table-responsive">
              <table className="table table-striped table-bordered mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>Project Name</th>
                    <th>Vehicle Type</th>
                    <th>Vehicle No</th>
                    <th>Owner</th>
                    <th>Owner Ship</th>
                    <th>Issued To</th>
                    <th>Item Type</th>
                    <th>Qty(L)</th>
                    <th>Rate</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="12" className="text-center py-4">
                        <div className="spinner-border text-primary"></div>
                      </td>
                    </tr>
                  ) : reports.length === 0 ? (
                    <tr>
                      <td colSpan="12" className="text-center text-muted">
                        No fuel consumption data found
                      </td>
                    </tr>
                  ) : (
                    reports.map((r, index) => (
                      <tr key={index}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{utility.formatDateDDMMMYYYY(r.fuelEntryDate)}</td>
                        <td>{formatProjectDisplay(r)}</td>
                        <td>{r.vehicleType || "-"}</td>
                        <td>{r.vehicleNumber || "-"}</td>
                        <td>{r.ownerName || "-"}</td>
                        <td>{r.ownershipType || "-"}</td>
                        <td>{r.issuedTo || "-"}</td>
                        <td>{r.itemType || "-"}</td>
                        <td className="text-end">{Number(r.qty || 0).toFixed(2)}</td>
                        <td className="text-end">{Number(r.rate || 0).toFixed(2)}</td>
                        <td className="text-end">{Number(r.amount || 0).toFixed(2)}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>

              <ReactPaginate
                breakLabel="..."
                nextLabel="Next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="< Previous"
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
                forcePage={currentPage - 1}
              />
            </div>
          </div>

        </div >
      </div >
    </>
  );
}
